import React, { Component } from 'react';
import { Button, Spin, Table, Tag, notification, Col, Row, Modal, message, Icon } from 'antd';
import moment from 'moment';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import ButtonComponent from 'components/controls/Button';
// import Model from 'components/controls/Model';
import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
import { NEW_ATTENDANCE_SHEET_HEADER } from "../../constants/constants";
import AttendanceDataTable from '../../components/controls/AttendanceDataTable';
import _utils from '../../modules/Utils';
import PageHeader from 'components/enterprise/PageHeader';
import _notification from 'modules/notification';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
// import { display } from 'html2canvas/dist/types/css/property-descriptors/display';


class GenerateAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      centerList: [],
      batchList: [],
      postList: [],
      attendanceData: [],
      candidateData: [],
      totalCandidate: 0,
      selectedCenter: null,
      selectedBatch: null,
      selectedPost: null,
      loading: false,
      ModalTableflag: false,
      newAttendanceSheetHeader: NEW_ATTENDANCE_SHEET_HEADER,
      RoomRecord: {},
      totalCount: 0,
      showDeleteConfirm: false,
    };
    this.tableRefs = []; // Create a ref for the table
  }

  componentDidMount() {
    this.fetchCenters();
  }

  //Converts an array into objects with Id and Name keys for dropdown options.
  transformArray = (responseArray) => {
    return responseArray.map((item) => ({
      Id: item,
      Name: item,
    }));
  };

  // Fetch centers when the page loads
  fetchCenters = async () => {
    this.setState({ loading: true });
    try {
      const response = await _AdminService.GetAllCenterList();   // Assuming API returns data in response.data
      console.log(response.data);
      this.setState({ centerList: this.transformArray(response.data), loading: false });
      console.log(this.state.centerList);
    } catch (error) {
      this.setState({ loading: false });
      _notification.showMessage('error', 'Unable to load centers. Please try again.');
    }
  };

  // Handle center selection change
  handleCenterChange = async (event) => {
    // debugger
    this.setState({ selectedCenter: event.target.value, loading: true, postList: [], batchList: [], attendanceData: [], selectedBatch: null, selectedPost: null ,totalCount: 0});
    try {
      // Fetch batches based on selected center
      const response = await _AdminService.GetAllBatchCenterByName(event.target.value);
      // console.log(response.data);

      this.setState({ batchList: this.transformArray(response.data), loading: false });
      // console.log(this.state.batchList);

    } catch (error) {
      this.setState({ loading: false });
      _notification.showMessage('error', 'Unable to load batches for the selected center. Please try again.');
    }
  };

  // Handle center selection change
  handleBatchChange = async (event) => {
    // debugger
    this.setState({ selectedBatch: event.target.value, postList: [], loading: true, attendanceData: [], selectedPost: null,totalCount: 0 });
    try {
      // Fetch batches based on selected center
      const response = await _AdminService.GetDistinctPostByCenterAndBatch(this.state.selectedCenter, event.target.value);
      // console.log(response.data);

      this.setState({ postList: this.transformArray(response.data), loading: false });
      // console.log(this.state.batchList);

    } catch (error) {
      this.setState({ loading: false });
      _notification.showMessage('error', 'Unable to load posts for the selected batch. Please try again.');
    }
  };

  // Handle batch selection change
  handlePostChange = async (event) => {
    this.setState({ selectedPost: event.target.value, loading: true, attendanceData: [], totalCount: 0 });
    try {
      // Fetch attendance data based on selected batch
      const response = await _AdminService.GetAllAttendanceData(this.state.selectedCenter, this.state.selectedBatch, event.target.value);

      this.setState({ attendanceData: response.data.Obj, totalCount: response.data.Obj.length, loading: false });
      console.log(this.state.attendanceData);

    } catch (error) {
      this.setState({ loading: false });
      _notification.showMessage('error', 'Unable to load attendance data for the selected post. Please try again.');
    }
  };

  deleteStudentAttendance = async () => {
    this.setState({ loading: true });
    try {
      const response = await _AdminService.DeleteStudentAttendanceData();

      if (response.data.IsSuccess) {
        this.setState({
          centerList: [],
          batchList: [],
          postList: [],
          attendanceData: [],
          candidateData: [],
          totalCandidate: 0,
          selectedCenter: null,
          selectedBatch: null,
          selectedPost: null,
          loading: false
        });
      } else {
        this.setState({ loading: false });
      }
      console.log("response", response)
      this.setState({ loading: false }); // Set state in one call

    } catch (error) {
      this.setState({ loading: false });
      _notification.showMessage('error', 'Unable to delete attendance data. Please try again.');
    }
  };

  // Handle center selection change
  onCancel = async (event) => {
    // debugger
    this.setState({ ModalTableflag: false });
  };

  onViewClick = async (record) => {
    try {
      this.setState({ isLoading: true });

      const response = await _AdminService.GetStudentDataForAttendance(record.StartRoleNumber, record.EndRoleNumber);
      console.log(response);


      const candidates = response.data.Obj;



      const updatedCandidates = candidates.map((candidate) => ({
        ...candidate,
        candidateSignature: "",
        candidateName: `${candidate.Firstname || ''} ${candidate.MiddleName || ''} ${candidate.LastName || ''}`.trim(),
      }));

      // const updatedCandidates = candidates.map((candidate) => ({
      //   ...candidate,
      //   candidateSignature: "",
      //   candidateName: `${candidate.Firstname || ''} ${candidate.MiddleName || ''} ${candidate.LastName || ''}`.trim(),
      //   Profile_Pic_PathBase: "sda",
      //   Signature_PathBase:"asd"
      // }));



      // const candidateDataChunk = [];
      // const firstChunkSize = 16;
      // const subsequentChunkSize = 20;

      // // Process the first chunk
      // if (updatedCandidates.length > 0) {
      //   const firstChunk = updatedCandidates.slice(0, firstChunkSize);
      //   candidateDataChunk.push(firstChunk);
      // }
      // // Model
      // // Process the subsequent chunks
      // for (let i = firstChunkSize; i < updatedCandidates.length; i += subsequentChunkSize) {
      //   const chunk = updatedCandidates.slice(i, i + subsequentChunkSize);
      //   candidateDataChunk.push(chunk);
      // }

      this.setState({
        fieldDisable: true,
        // candidateData: candidateDataChunk,
        candidateData: [updatedCandidates],
        isLoading: false,
        totalCandidate: updatedCandidates.length,
        ModalTableflag: true,
        RoomRecord: record
      });

    } catch (e) {
      console.error("Error:", e);
      this.setState({ isLoading: false });
    }
  };

  generatePostData = async () => {
    try {
      this.setState({ isLoading: true });

      const response = await _AdminService.GetAllAttendanceData(this.state.selectedCenter, this.state.selectedBatch, this.state.selectedPost);

      console.log(response); // Log the response to check if it's valid

      const records = response.data.Obj;  // Array of records

      if (!records || records.length === 0) {
        _notification.showMessage('error', 'No records found for the selected post.');
        this.setState({ isLoading: false });
        return;
      }

      // Filter records based on selected post (e.g., "Peon")
      const filteredRecords = records.filter(record => record.Post === this.state.selectedPost);

      if (filteredRecords.length === 0) {
        _notification.showMessage('error', 'No records found for the selected post.');
        this.setState({ isLoading: false });
        return;
      }

      // Merge the roll number ranges from all filtered records for the selected post
      let allRollNumbers = [];
      filteredRecords.forEach(record => {
        const rollNumbersInRange = Array.from(
          { length: record.EndRoleNumber - record.StartRoleNumber + 1 },
          (_, index) => record.StartRoleNumber + index
        );
        allRollNumbers = allRollNumbers.concat(rollNumbersInRange);
      });

      console.log(allRollNumbers); // Check if all roll numbers are being correctly populated

      // Create a new jsPDF document
      const doc = new jsPDF({
        compress: true, // Enable internal compression
      });

      // Set header font size and add the header
      doc.setFontSize(14); // Set font size for header
      doc.setFont("helvetica", "bold");

      // Add details at the top
      const details = [
        { label: "Batch Time", value: filteredRecords[0].BatchTime.replace(/_/g, ' ') || "N/A" }, // Replacing underscores with spaces
        { label: "Batch Name", value: filteredRecords[0].BatchName || "N/A" }, // No need to replace underscores in BatchName
        { label: "Date", value: moment(filteredRecords[0].ExamDate).format('DD-MMM-YYYY') || "N/A" }, // Formatting date
        { label: "Post Name", value: filteredRecords[0].Post || "N/A" }, // Direct value for Post
      ];

      const xLeft = 10;
      let yPos = 37;
      const lineHeight = 9;

      // Left column
      doc.setLineWidth(0.1);
      doc.rect(5, 8, 200, 45);
      doc.setFont("helvetica", "bold");

      // Define the maximum width for the text within the header box
      const maxWidth = 190; // Slightly less than the box width for padding

      // Split the text to fit within the specified width
      const headerText = doc.splitTextToSize(this.state.newAttendanceSheetHeader, maxWidth);

      // Starting y position for the text
      let yPosition = 15;

      // Draw the first line of text (left-aligned)
      doc.text(headerText[0], 10, yPosition, { align: "left" });
      yPosition += 5; // Increment y for the next line

      // Draw the remaining lines (center-aligned)
      headerText.slice(1).forEach((line) => {
        // Get the width of the text to calculate the X position for centering
        const textWidth = doc.getTextWidth(line);

        // Calculate the x position to center the text
        const xPosition = (maxWidth - textWidth) / 2 + 10; // Adjusted x to center it inside the box

        // Draw the text center-aligned
        doc.text(line, xPosition, yPosition);
        yPosition += 5; // Increment y for the next line
      });

      // Set font size to 13 for content below the header
      doc.setFontSize(15); // Change font size to 13 for the content

      doc.setFont("helvetica", "normal");
      const X = 10;
      const Y = 28;
      doc.text("Center: " + filteredRecords[0].CenterName, X, Y);

      details.slice(0, 2).forEach((item) => {
        doc.text(`${item.label}: ${item.value}`, xLeft, yPos);
        yPos += lineHeight;
      });

      // Right column
      yPos = 37;
      details.slice(2, 4).forEach((item) => {
        doc.text(`${item.label}: ${item.value}`, 150, yPos);
        yPos += lineHeight;
      });

      // Roll numbers section
      const pageWidth = doc.internal.pageSize.width; // Total page width
      const margin = 5; // Left and right margins
      let availableWidth = pageWidth - 2 * margin; // Content area width

      // Define font size and calculate text width dynamically
      const fontSize = 15; // Adjust this value based on the desired font size
      doc.setFontSize(fontSize);

      // Prepare all roll numbers in a single string, and split into lines if necessary
      let rollNumbersInOneRow = allRollNumbers.join('    '); // Add space between roll numbers

      // Add a new page if the content doesn't fit within the current page width
      let contentWidth = doc.getTextWidth(rollNumbersInOneRow);

      if (contentWidth > availableWidth) {
        // Content is too wide, split the text into lines manually
        let lines = [];
        let currentLine = '';
        allRollNumbers.forEach((rollNumber) => {
          let testLine = currentLine + rollNumber + '    '; // Add spacing
          if (doc.getTextWidth(testLine) < availableWidth) {
            currentLine = testLine;
          } else {
            lines.push(currentLine.trim());
            currentLine = rollNumber + '    '; // Start a new line with the current roll number
          }
        });
        lines.push(currentLine.trim()); // Push the last line

        // Generate the table with multiple lines if needed
        doc.autoTable({
          head: [
            ['Building Name', 'Floor Name', 'Room Name', 'Start Roll Number', 'End Roll Number', 'Count']
          ],
          body: filteredRecords.map(record => [
            record.BuildingName || 'N/A',
            record.FloorName || 'N/A',
            record.RoomName || 'N/A',
            record.StartRoleNumber || 'N/A',
            record.EndRoleNumber || 'N/A',
            record.Count || 'N/A',
          ]),
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            lineWidth: 0.1,
            lineColor: [0, 0, 0],
            cellPadding: 2,
          },
          styles: {
            font: 'helvetica',
            fontSize: 10,
            textColor: [0, 0, 0],
            cellPadding: 3,
            lineWidth: 0.1,
            lineColor: [0, 0, 0],
            fillColor: [255, 255, 255], // White background for all cells
            valign: 'top', // Align content to the top
            halign: 'left', // Align text to the left
          },
          rowPageBreak: 'avoid',
          alternateRowStyles: {
            fillColor: [255, 255, 255],
          },
          startY: 65, // Start the table at Y position 70 (adjust if needed)
          margin: { left: margin, right: margin },
        });
      }

      // Save the PDF
      const pdfFileName = `Attendance_Sheet_${filteredRecords[0].Post}_${filteredRecords[0].CenterName}.pdf`;
      doc.save(pdfFileName);

      this.setState({ isLoading: false });

    } catch (e) {
      console.error("Error:", e);
      this.setState({ isLoading: false });
    }
  };

  handleDeleteConfirmation = () => {
    this.setState({ showDeleteConfirm: true });
  };


  render() {
    const { centerList, batchList, postList, attendanceData, loading } = this.state;

    const TableColumns = [
      // {
      //   title: 'ID',
      //   dataIndex: 'Id',
      //   key: 'Id',
      //   width: '5%',
      //   sorter: (a, b) => a.Id - b.Id
      // },
      {
        title: 'Center',
        dataIndex: 'Center',
        key: 'Center',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.Center.localeCompare(b.Center)
      },
      {
        title: 'Center Name',
        dataIndex: 'CenterName',
        key: 'CenterName',
        width: '13%',
        filterSearch: true,
        sorter: (a, b) => a.CenterName.localeCompare(b.CenterName)
      },
      {
        title: 'Building Name',
        dataIndex: 'BuildingName',
        key: 'BuildingName',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.BuildingName.localeCompare(b.BuildingName)
      },
      {
        title: 'Floor Name',
        dataIndex: 'FloorName',
        key: 'FloorName',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.FloorName.localeCompare(b.FloorName)
      },
      {
        title: 'Room Name',
        dataIndex: 'RoomName',
        key: 'RoomName',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.RoomName.localeCompare(b.RoomName)
      },
      {
        title: 'Batch Name',
        dataIndex: 'BatchName',
        key: 'BatchName',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.BatchName.localeCompare(b.BatchName)
      },
      {
        title: 'Batch Time',
        dataIndex: 'BatchTime',
        key: 'BatchTime',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.BatchTime.localeCompare(b.BatchTime)
      },
      {
        title: 'Start Roll Number',
        dataIndex: 'StartRoleNumber',
        key: 'StartRoleNumber',
        width: '10%', sorter: (a, b) => a.StartRoleNumber - b.StartRoleNumber
      },
      {
        title: 'End Roll Number',
        dataIndex: 'EndRoleNumber',
        key: 'EndRoleNumber',
        width: '10%',
        sorter: (a, b) => a.EndRoleNumber - b.EndRoleNumber
      },
      {
        title: 'Count',
        dataIndex: 'Count',
        key: 'Count',
        width: '8%',
        render: (text, record) =>
          (record.EndRoleNumber !== 0 && record.StartRoleNumber !== 0) ? (record.EndRoleNumber - record.StartRoleNumber) + 1 : 0
      },
      {
        title: 'Exam Date',
        dataIndex: 'ExamDate',
        key: 'ExamDate',
        width: '10%',
        render: (text, record) => moment(record.ExamDate).isValid() ? moment(record.ExamDate).format('DD-MMM-YYYY') : '',
        sorter: (a, b) => moment(a.ExamDate).unix() - moment(b.ExamDate).unix()
      },
      {
        title: 'Post',
        dataIndex: 'Post',
        key: 'Post',
        width: '10%',
        filterSearch: true,
        sorter: (a, b) => a.Post.localeCompare(b.Post)
      },
      {
        title: 'Action',
        dataIndex: '',
        key: 'Action',
        width: '100px',
        render: (text, record) => (
          <Tag onClick={() => this.onViewClick(record)} color="green">View</Tag>
        ),
      }
    ];

    return (
      <Spin spinning={loading}>
        <div className="container-fluid p-3">
          <PageHeader
            title="Generate Attendance"
            breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Attendance' }, { label: 'Generate Attendance' }]}
          />
          <div className="ent-panel mb-3">
          <Row gutter={16} className="m-0 d-flex align-items-center">
            <Col span={4} className="d-flex align-items-center">
              <label htmlFor="center" className="mb-0 mr-2">Center:</label>
              <DropdownList
                id="center"
                placeholder="Select Center"
                options={centerList}
                onChange={this.handleCenterChange}
                value={this.state.selectedCenter}
                name="Center"
                wrapClass=" w-100  mb-0"
              />
            </Col>
            <Col span={4} className="d-flex align-items-center">
              <label htmlFor="center" className="mb-0 mr-2">Batch:</label>
              <DropdownList
                wrapClass=" w-100 mb-0"
                id="batch"
                placeholder="Select Batch"
                options={batchList}
                onChange={this.handleBatchChange}
                value={this.state.selectedBatch}
                name="Batch"
                disabled={!this.state.selectedCenter}
              />
            </Col>

            <Col span={4} style={{ display: "flex" }}>
              <label htmlFor="post" style={{ marginRight: '10px', marginTop: "8px" }} className="mb-0">Post:</label>
              <DropdownList
                wrapClass="w-100 mb-0"
                id="post"  // Ensures the ID is associated with the label
                placeholder="Select post"
                options={postList}
                onChange={this.handlePostChange}
                value={this.state.selectedPost}
                name="post"
                disabled={!this.state.selectedCenter}
              />
            </Col>
            <Col span={2} style={{ fontWeight: "bold", marginLeft: "15px" }}>
              Total Records : {this.state.totalCount}
            </Col>
            <Col span={5}>
              <Button
                onClick={() => this.generatePostData()}
                className="button-global button-primary autoWidth autoHeight"
              >
                Export Center Post-Wise Data
              </Button>

            </Col>

            <Col span={4} className="d-flex align-items-center justify-content-end pr-0">
              <a
                type="primary"
                danger
                className="button-global button-border removebutton addbutton autoWidth d-inline-block text-center autoHeight"
                onClick={this.handleDeleteConfirmation}
              >   <Icon type="delete" className="mr-2 align-middle mb-1" />
                Delete Candidate Attendance Data
              </a>
            </Col>
          </Row>
          </div>
          <div className="mt-3">
            <Table
              size="small"
              columns={TableColumns}
              dataSource={attendanceData}
              rowKey="Id"
              pagination={false}
              className="table-striped-rows admin-table "
            />
          </div>
        </div>
        <div>
          <Modal
            visible={this.state.ModalTableflag}
            footer={null}
            onCancel={this.onCancel}
            className="modelPopAnt admin-home"
            // footer={[
            //   <Button key="cancel" onClick={handleCancel}>
            //     Cancel
            //   </Button>
            // ]}
            width="80%"
            bodyStyle={{ height: '85vh', padding: 0, overflowX: 'hidden', overflowY: "scroll" }}
          >
            <AttendanceDataTable candidateData={this.state.candidateData} RoomRecord={this.state.RoomRecord} onCancel={this.onCancel} totalCandidate={this.state.totalCandidate} />
          </Modal>
          <Modal
            footer={false}
            onCancel={() => this.setState({ showDeleteConfirm: false })}
            visible={this.state.showDeleteConfirm}
            className="modelPopAnt admin-home"
          >
            <ConfirmPopup
              message="Are you sure? Do you want to delete the student attendance data?"
              onCancel={() => {
                console.log("Operation canceled.");
                this.setState({ showDeleteConfirm: false });
              }}
              onOk={() => {
                this.setState({ showDeleteConfirm: false });
                return new Promise((resolve, reject) => {
                  this.deleteStudentAttendance()
                    .then(() => {
                      message.success("Candidate attendance data deleted successfully!");
                      resolve();
                    })
                    .catch((error) => {
                      message.error("Failed to delete student attendance data.");
                      console.error("Failed to delete student attendance data:", error);
                      reject();
                    });
                });
              }}
            />
          </Modal>
        </div>
      </Spin>
    );
  }
}
export default GenerateAttendance;




